import {assertAndContinue} from 'Asserts';
import {EventConstants} from 'constants/EventConstants';
import type {StructuredTableEventPayload} from 'constants/events/StructuredTableEventPayloads';
import AppDispatcher from 'lib/Dispatcher';
import {TableCellEditorPosition} from 'notebook/tables/constants/CellConstants';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

export function setFormula({
  tableNamespace,
  tableName,
  fileId,
  documentName,
  index,
  formula,
  typedValue,
  editing,
  selection,
  cellInsertMode,
}: StructuredTableEventPayload['SPREADSHEET_SET_FORMULA']): void {
  // Make sure we didn't forget typedValue.
  // To clear typedValue, you can pass in `null`.
  assertAndContinue(typedValue !== undefined, 'typedValue is required');

  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_FORMULA,
    tableNamespace,
    tableName,
    fileId,
    documentName,
    index,
    formula,
    typedValue,
    editing,
    selection,
    cellInsertMode,
  });
}

export function setTypedValue(typedValue: TypedValue | null): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_TYPED_VALUE,
    typedValue,
  });
}

export function setCellEditorPosition(cellEditorPosition: TableCellEditorPosition | null): void {
  AppDispatcher.dispatch({
    actionType: EventConstants.SPREADSHEET_SET_CELL_EDITOR_POSITION,
    cellEditorPosition,
  });
}
